import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Glass } from "./Glass.vue"

export const glassVariants = cva(
  [
    // base
    "relative isolate border backdrop-blur-md",
    // theme-aware background using tokens
    "bg-card/15 dark:bg-card/5",
    // subtle elevation and ring for crisp edges
    "shadow-md ring-1 ring-black/5 dark:ring-white/5",
    // smooth interactions
    "transition-[background,box-shadow,transform] will-change-[background,box-shadow,transform]",
  ].join(" "),
  {
    variants: {
      blur: {
        none: "backdrop-blur-0",
        xs: "backdrop-blur-xs",
        sm: "backdrop-blur-sm",
        md: "backdrop-blur-md",
        lg: "backdrop-blur-lg",
        xl: "backdrop-blur-xl",
      },
      tint: {
        none: "",
        light: "bg-white/20 dark:bg-white/5",
        dark: "bg-black/20 dark:bg-black/40",
        primary: "bg-primary/20",
        accent: "bg-accent/20",
      },
      elevation: {
        none: "shadow-none",
        sm: "shadow-sm",
        md: "shadow-md",
        lg: "shadow-lg",
      },
      border: {
        none: "border-transparent",
        muted: "border-white/20 dark:border-white/10",
        strong: "border-white/40 dark:border-white/20",
      },
      interactive: {
        true: "hover:bg-card/50 hover:shadow-xl active:scale-[0.995]",
        false: "",
      },
      padding: {
        none: "p-0",
        sm: "p-2",
        md: "p-4",
        lg: "p-6",
      },
      rounded: {
        none: "",
        sm: "rounded-md",
        md: "rounded-lg",
        lg: "rounded-xl",
        full: "rounded-full",
      },
    },
    defaultVariants: {
      blur: "sm",
      tint: "none",
      elevation: "md",
      border: "muted",
      interactive: false,
      padding: "none",
      rounded: "md",
    },
  },
)

export type GlassVariants = VariantProps<typeof glassVariants>